var map = {
	"./10Ton-PickUp-gray.png": 17778,
	"./10Ton-PickUp-green.png": 39642,
	"./10Ton-PickUp-red.png": 29473,
	"./10Ton-PickUp-yellow.png": 53959,
	"./2Ton-PickUp-black.png": 90758,
	"./2Ton-PickUp-gray.png": 92960,
	"./2Ton-PickUp-green.png": 86279,
	"./2Ton-PickUp-purple.png": 5519,
	"./2Ton-PickUp-red.png": 88213,
	"./2Ton-PickUp-yellow.png": 49429,
	"./3Ton-PickUp-gray.png": 73478,
	"./3Ton-PickUp-green.png": 65570,
	"./3Ton-PickUp-red.png": 47555,
	"./3Ton-PickUp-yellow.png": 50201,
	"./5Ton-PickUp-gray.png": 66496,
	"./5Ton-PickUp-green.png": 95217,
	"./5Ton-PickUp-red.png": 14158,
	"./5Ton-PickUp-yellow.png": 34036,
	"./Ambulance-black.png": 24609,
	"./Ambulance-gray.png": 21446,
	"./Ambulance-green.png": 57958,
	"./Ambulance-purple.png": 64102,
	"./Ambulance-red.png": 76730,
	"./Ambulance-yellow.png": 38437,
	"./Boom-Loader-black.png": 60925,
	"./Boom-Loader-gray.png": 74150,
	"./Boom-Loader-green.png": 58177,
	"./Boom-Loader-purple.png": 9556,
	"./Boom-Loader-red.png": 18743,
	"./Boom-Loader-yellow.png": 72449,
	"./Bulldozer-black.png": 51017,
	"./Bulldozer-gray.png": 33771,
	"./Bulldozer-green.png": 90813,
	"./Bulldozer-purple.png": 27425,
	"./Bulldozer-red.png": 72612,
	"./Bulldozer-yellow.png": 80028,
	"./Canter-gray.png": 81708,
	"./Canter-green.png": 85299,
	"./Canter-red.png": 7498,
	"./Canter-yellow.png": 34880,
	"./Car-black.png": 99395,
	"./Car-gray-1.png": 52236,
	"./Car-gray.png": 32356,
	"./Car-green.png": 57663,
	"./Car-purple - Copy.png": 47456,
	"./Car-red.png": 62220,
	"./Car-yellow.png": 16002,
	"./Coaster-Bus-black.png": 12713,
	"./Coaster-Bus-gray.png": 37798,
	"./Coaster-Bus-green.png": 2847,
	"./Coaster-Bus-purple.png": 70578,
	"./Coaster-Bus-red.png": 18026,
	"./Coaster-Bus-yellow.png": 7091,
	"./Crane-black.png": 97984,
	"./Crane-gray.png": 76966,
	"./Crane-green.png": 13800,
	"./Crane-purple.png": 4325,
	"./Crane-red.png": 48612,
	"./Crane-yellow.png": 13498,
	"./Dumper-black.png": 16308,
	"./Dumper-gray.png": 37026,
	"./Dumper-green.png": 36965,
	"./Dumper-purple.png": 57807,
	"./Dumper-red.png": 41374,
	"./Dumper-yellow.png": 88364,
	"./Excavator-black.png": 26314,
	"./Excavator-gray.png": 88972,
	"./Excavator-green.png": 88503,
	"./Excavator-purple.png": 88071,
	"./Excavator-red.png": 8604,
	"./Excavator-yellow.png": 26011,
	"./Forklif-black.png": 66154,
	"./Forklif-gray.png": 17806,
	"./Forklif-green.png": 25209,
	"./Forklif-purple.png": 23890,
	"./Forklif-red.png": 50047,
	"./Forklif-yellow.png": 39913,
	"./Generator-black.png": 94452,
	"./Generator-gray.png": 44862,
	"./Generator-green.png": 10408,
	"./Generator-purple.png": 61509,
	"./Generator-red.png": 58327,
	"./Generator-yellow.png": 38205,
	"./Hiace-black.png": 68015,
	"./Hiace-gray.png": 2621,
	"./Hiace-green.png": 8273,
	"./Hiace-red.png": 58411,
	"./Hiace-yellow.png": 59010,
	"./Hilux-gray.png": 15849,
	"./Hilux-green.png": 90508,
	"./Hilux-red.png": 82723,
	"./Hilux-yellow.png": 21106,
	"./JCB-black.png": 59207,
	"./JCB-gray.png": 85340,
	"./JCB-green.png": 17908,
	"./JCB-red.png": 52299,
	"./JCB-yellow.png": 45851,
	"./Mini-Bus-gray.png": 83822,
	"./Mini-Bus-green.png": 62325,
	"./Mini-Bus-red.png": 26569,
	"./Mini-Bus-yellow.png": 54385,
	"./Motorcycle-black.png": 80455,
	"./Motorcycle-gray.png": 72418,
	"./Motorcycle-green.png": 88307,
	"./Motorcycle-purple.png": 98242,
	"./Motorcycle-red.png": 98272,
	"./Motorcycle-yellow.png": 15337,
	"./PickUp-gray.png": 5184,
	"./PickUp-green.png": 81352,
	"./PickUp-red.png": 46022,
	"./PickUp-yellow.png": 16343,
	"./Roller-black.png": 43504,
	"./Roller-gray.png": 3300,
	"./Roller-green.png": 64103,
	"./Roller-purple.png": 32075,
	"./Roller-red.png": 32029,
	"./Roller-yellow.png": 75696,
	"./SUV-black.png": 96171,
	"./SUV-gray.png": 88530,
	"./SUV-green.png": 45484,
	"./SUV-purple.png": 6463,
	"./SUV-red.png": 4692,
	"./SUV-yellow.png": 22719,
	"./SchoolBus-black.png": 61891,
	"./SchoolBus-gray.png": 61488,
	"./SchoolBus-green.png": 34487,
	"./SchoolBus-red.png": 90679,
	"./SchoolBus-yellow.png": 14138,
	"./Tanker-black.png": 43898,
	"./Tanker-gray.png": 47445,
	"./Tanker-green.png": 94121,
	"./Tanker-purple.png": 82178,
	"./Tanker-red.png": 48442,
	"./Tanker-yellow.png": 4218,
	"./Tourist-Bus-black.png": 15913,
	"./Tourist-Bus-gray.png": 84950,
	"./Tourist-Bus-green.png": 92898,
	"./Tourist-Bus-purple.png": 17994,
	"./Tourist-Bus-red.png": 24902,
	"./Tourist-Bus-yellow.png": 3368,
	"./Truck-black.png": 24910,
	"./Truck-gray.png": 58186,
	"./Truck-green.png": 51762,
	"./Truck-purple.png": 45354,
	"./Truck-red.png": 42099,
	"./Truck-yellow.png": 44651,
	"./Urvan-black.png": 79533,
	"./Urvan-gray.png": 62522,
	"./Urvan-green.png": 34285,
	"./Urvan-purple.png": 11145,
	"./Urvan-red.png": 30283,
	"./Urvan-yellow.png": 26986,
	"./Van-gray.png": 80898,
	"./Van-green.png": 28987,
	"./Van-red.png": 53507,
	"./Van-yellow.png": 39461,
	"./Yatch-black.png": 23123,
	"./Yatch-gray.png": 40048,
	"./Yatch-green.png": 69004,
	"./Yatch-purple.png": 14433,
	"./Yatch-red.png": 77319,
	"./Yatch-yellow.png": 7960,
	"./car-icon-blue.png": 41982,
	"./default-black.png": 54024,
	"./default-gray.png": 46298,
	"./default-green.png": 78090,
	"./default-purple.png": 79735,
	"./default-red.png": 25600,
	"./default-yellow.png": 85781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42344;